import { Visible } from "util/enhancer";
import { Tooltip } from "./Tooltip";

type DetailsColumnProps = {
  label: string;
  value: string | number | null;
  tooltipText?: string;
  tooltipId?: string;
};
export const DetailsColumn = (props: DetailsColumnProps) => (
  <div className="item">
    <div className="d-flex">
      <div className="name">{props.label}</div>
      {props.tooltipText && (
        <Tooltip id={`${props.tooltipId}-tooltip`} text={props.tooltipText} />
      )}
    </div>
    <div className="value">{props.value}</div>
  </div>
);

export const VisibleDetailsColumn = Visible(DetailsColumn);
